/**
 * Current storefront store code, derived from the language the server renders on
 * the document (`en-CA` => Canada store under the `/ca` path prefix, otherwise the
 * US store). Mirrors the convention already used by the analytics trackers.
 */
export const currentStoreCode = (): "ca" | "us" =>
  document.documentElement.lang === "en-CA" ? "ca" : "us";

/**
 * Store-aware cart path. The Canada store lives under the `/ca` path prefix, so a
 * bare `/cart` navigation bounces a CA guest to the US store and resets their
 * resolved location (MN-4822). Always use this for client-side cart navigation.
 */
export const cartPath = (): string => (currentStoreCode() === "ca" ? "/ca/cart" : "/cart");
